import PadCreator from '../PadCreator';
// utils
import _ from 'lodash';
import { codeGeneretor } from 'app/utils';
// consts
import { TYPE } from 'app/config/prescription_content';
// classes
import { PadPrescriptionType } from './PadPrescriptionType';

/**
 * represents an instance of PadPrescriptionProcedure
 * @class PadPrescriptionProcedure
 * @extends PadCreator
 */
export default class PadPrescriptionProcedure extends PadCreator {
  prepare(padPrescriptionProcedures = []) {
    const preparedProcedures = padPrescriptionProcedures.map(padPrescriptionProcedure => {
      const code = codeGeneretor();
      const type = TYPE.SUSTEINED; // mantido

      const padPrescriptionSuggestSched =
        padPrescriptionProcedure.padPrescriptionSuggestionScheduling;

      padPrescriptionProcedure.suggestScheduling = _.isEmpty(padPrescriptionSuggestSched) ? 0 : 1;

      return {
        code,
        type,
        padPrescriptionProcedure
      };
    });

    this._loadedData = _.cloneDeep(preparedProcedures);
    this._screenData = _.cloneDeep(preparedProcedures);

    return this;
  }

  /**
   * insert a new procedure.
   * @param {object} procedure - new procedure.
   * @returns {object} the state
   */
  add(procedure) {
    const padPrescription = _.cloneDeep(procedure);

    padPrescription.code = codeGeneretor();

    this._screenData.push(padPrescription);

    return this;
  }

  /**
   * update a procedure.
   * @param {string} code - procedure`s code to be edited.
   * @param {object} procedure - procedure to be edited.
   * @returns {object} return the state
   */
  edit(code, procedure = {}) {
    const screenData = _.cloneDeep(this._screenData);
    const loadedData = _.cloneDeep(this._loadedData);
    const padPrescription = _.cloneDeep(procedure);

    // find index by code
    const indexScreenToEdit = [...this._screenData].findIndex(item => item.code === code);

    Object.entries(padPrescription).forEach(([key, content]) => {
      this._screenData[indexScreenToEdit][key] = content;
    });

    const padPrescriptionType = new PadPrescriptionType({ screenData, loadedData });
    const type = padPrescriptionType.getTypeOnEdit(padPrescription);

    this._screenData[indexScreenToEdit].type = type;

    return this;
  }

  /**
   * remove a element.
   * @param {string} code - element`s code to remove.
   * @returns {object} return the state
   */
  remove(code) {
    const newScreen = [...this._screenData].filter(currentElement => currentElement.code !== code);

    this._screenData = newScreen;

    return this;
  }
}
